export default __webpack_public_path__ + "static/media/lock.70196f59.svg";